import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";

// pages

import UsersTable from "./taxpayers/TaxpayerList";
import CreateTaxpayer from "./taxpayers/CreateTaxpayer";



import Presentation from "./Presentation";
import Upgrade from "./Upgrade";
import DashboardOverview from "./dashboard/DashboardOverview";
import Settings from "./settings/AppConfigList";
import BootstrapTables from "./tables/BootstrapTables";
import Signin from "./examples/Signin";
import Signup from "./examples/Signup";
import ForgotPassword from "./examples/ForgotPassword";
import ResetPassword from "./examples/ResetPassword";
import Lock from "./examples/Lock";
import NotFoundPage from "./examples/NotFound";
import ServerError from "./examples/ServerError";

// documentation pages
import DocsOverview from "./documentation/DocsOverview";
import DocsDownload from "./documentation/DocsDownload";
import DocsQuickStart from "./documentation/DocsQuickStart";
import DocsLicense from "./documentation/DocsLicense";
import DocsFolderStructure from "./documentation/DocsFolderStructure";
import DocsBuild from "./documentation/DocsBuild";
import DocsChangelog from "./documentation/DocsChangelog";

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";

import Accordion from "./components/Accordion";
import Alerts from "./components/Alerts";
import Badges from "./components/Badges";
import Breadcrumbs from "./components/Breadcrumbs";
import Buttons from "./components/Buttons";
import Forms from "./components/Forms";
import Modals from "./components/Modals";
import Navs from "./components/Navs";
import Navbars from "./components/Navbars";
import Pagination from "./components/Pagination";
import Popovers from "./components/Popovers";
import Progress from "./components/Progress";
import Tables from "./components/Tables";
import Tabs from "./components/Tabs";
import Tooltips from "./components/Tooltips";
import Toasts from "./components/Toasts";

const RouteWithLoader = ({ element }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Preloader show={!loaded} />
      {loaded && element}
    </>
  );
};

const RouteWithSidebar = ({ element }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem("settingsVisible") === "false" ? false : true;
  };

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    const newState = !showSettings;
    setShowSettings(newState);
    localStorage.setItem("settingsVisible", newState);
  };

  return (
    <>
      <Preloader show={!loaded} />
      {loaded && (
        <>
          <Sidebar />
          <main className="content">
            <Navbar />
            {element}
            <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
          </main>
        </>
      )}
    </>
  );
};

export default function HomePage() {
  return (
    <Routes>

       <Route path="/" element={<Navigate to="/signin" replace />} />
       
      {/* Public pages with loader */}
      <Route path="/signin" element={<RouteWithLoader element={<Signin />} />} />
      <Route path="/signup" element={<RouteWithLoader element={<Signup />} />} />
      <Route path="/forgot-password" element={<RouteWithLoader element={<ForgotPassword />} />} />
      <Route path="/reset-password" element={<RouteWithLoader element={<ResetPassword />} />} />
      <Route path="/lock" element={<RouteWithLoader element={<Lock />} />} />
      <Route path="/404" element={<RouteWithLoader element={<NotFoundPage />} />} />
      <Route path="/500" element={<RouteWithLoader element={<ServerError />} />} />

      {/* Pages with sidebar */}
      <Route path="/home" element={<PrivateRoute element={<DashboardOverview />} />} />
      <Route path="/taxpayers" element={<PrivateRoute element={<UsersTable />} />} />
      <Route path="/taxpayers/create" element={<PrivateRoute element={<CreateTaxpayer />} />} />
      <Route path="/taxpayers/:id/edit" element={<PrivateRoute element={<CreateTaxpayer />} />} />
      <Route path="/settings" element={<PrivateRoute element={<Settings />} />} />
    
    
      <Route path="/bootstrap-tables" element={<RouteWithSidebar element={<BootstrapTables />} />} />
      <Route path="/upgrade" element={<RouteWithSidebar element={<Upgrade />} />} />
      <Route path="/accordions" element={<PrivateRoute element={<Accordion />} />} />
      <Route path="/alerts" element={<PrivateRoute element={<Alerts />} />} />
      <Route path="/badges" element={<PrivateRoute element={<Badges />} />} />
      <Route path="/breadcrumbs" element={<PrivateRoute element={<Breadcrumbs />} />} />
      <Route path="/buttons" element={<PrivateRoute element={<Buttons />} />} />
      <Route path="/forms" element={<PrivateRoute element={<Forms />} />} />
      <Route path="/modals" element={<PrivateRoute element={<Modals />} />} />
      <Route path="/navs" element={<PrivateRoute element={<Navs />} />} />
      <Route path="/navbars" element={<PrivateRoute element={<Navbars />} />} />
      <Route path="/pagination" element={<PrivateRoute element={<Pagination />} />} />
      <Route path="/popovers" element={<PrivateRoute element={<Popovers />} />} />
      <Route path="/progress" element={<PrivateRoute element={<Progress />} />} />
      <Route path="/tables" element={<PrivateRoute element={<Tables />} />} />
      <Route path="/tabs" element={<PrivateRoute element={<Tabs />} />} />
      <Route path="/tooltips" element={<PrivateRoute element={<Tooltips />} />} />
      <Route path="/toasts" element={<PrivateRoute element={<Toasts />} />} />

      {/* Documentation behind private route */}
      <Route path="/docs-overview" element={<PrivateRoute element={<DocsOverview />} />} />
      <Route path="/docs-download" element={<PrivateRoute element={<DocsDownload />} />} />
      <Route path="/docs-quickstart" element={<PrivateRoute element={<DocsQuickStart />} />} />
      <Route path="/docs-license" element={<PrivateRoute element={<DocsLicense />} />} />
      <Route path="/docs-folder-structure" element={<PrivateRoute element={<DocsFolderStructure />} />} />
      <Route path="/docs-build" element={<PrivateRoute element={<DocsBuild />} />} />
      <Route path="/docs-changelog" element={<PrivateRoute element={<DocsChangelog />} />} />

      {/* Catch all - redirect to 404 */}
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}
